import styled from "@emotion/styled";
import {PC, Mobile} from "../../../../hooks/util/useMediaquery";

import SubscriptionCompletePC from "./PC/SubscriptionComplete"
import SubscriptionCompleteMobile from "./Mobile/SubscriptionComplete";

const Elem:React.FC<any> = () => {
  return (
    <>
      <PC>
        <SubscriptionCompletePC />
      </PC>

      <Mobile>
        <SubscriptionCompleteMobile />
      </Mobile>
    </>
  )
};

export default Elem;